import ClassListView from '@/views/classes/ClassListView.vue';
import EditClassView from '@/views/classes/EditClassView.vue';
import ClassGroupView from '@/views/classes/ClassGroupView.vue';
import AddClassView from '@/views/classes/AddClassView.vue';
import GroupStudentsIndex from '@/views/classes/GroupStudentsIndex.vue';
import AssignGroup from '@/views/classes/AssignGroup.vue';
import ClassSubjects from '@/views/classsubjects/ClassSubjectsIndex.vue';
import AddSubjectToClass from '@/views/classsubjects/AddClassSubject.vue';
import EditSubjectToClass from '@/views/classsubjects/EditClassSubject.vue';
import GroupScheduleView from '@/views/classes/GroupScheduleView.vue';
import ExamScheduleSettings from '@/views/classes/ExamScheduleSettings.vue';
import ExamScheduleView from '@/views/classes/ExamScheduleView.vue';
import ExamScheduleIndex from '@/views/classes/ExamScheduleIndex.vue';

export default [
  {
    path: '/classes',
    name: 'classes.index',
    component: ClassListView,
    meta: { 
      requiresAuth: true,
      title: 'classes.breadcrumbs.classes',
       requiredPerm: 'classes.display',
    },
    children: [
      {
        path: 'add',
        name: 'AddClass',
        component: AddClassView,
        meta: { 
          title: 'classes.breadcrumbs.addClass',
          requiresAuth: true,
          requiredPerm: 'classes.create',
        }
      },
      {
        path: ':classId/add-group',
        name: 'AssignGroup',
        component: AssignGroup,
        props: true,
        meta: { 
          title: 'groups.breadcrumbs.addGroup',
          requiresAuth: true,
          requiredPerm: 'class_groups.update',

        }
      },
      {
        path: ':id/edit',
        name: 'EditClass',
        component: EditClassView,
        meta: { 
          title: 'classes.breadcrumbs.editClass',
          requiresAuth: true,
          requiredPerm: 'classes.update',
        },
        props: true
      },
      {
        path: ':classId/groups',
        name: 'ClassGroups',
        component: ClassGroupView,
        props: true,
        meta: { 
          title: 'groups.breadcrumbs.groups',
          requiresAuth: true,
          requiredPerm: 'class_groups.display',
        },
        children: [
          {
            path: ':groupId/students', 
            name: 'GroupStudents',
            component: GroupStudentsIndex,
            meta: { 
              title: 'groups.breadcrumbs.students',
              requiresAuth: true,
                            requiredPerm: 'class_group_students.display',

            },
            props: true
          },
          {
            path: 'schedule/:groupId', 
            name: 'GroupSchedule',
            component: GroupScheduleView,
            props: true,
            meta: { 
              title: 'schedule.breadcrumbs.groupSchedule',
              requiresAuth: true,
                            requiredPerm: 'class_schedules.display',

            },
            children: [
              {
                path: 'settings',
                name: 'GroupScheduleSettings',
                component: () => import('@/views/classes/ScheduleSettings.vue'),
                meta: { 
                  title: 'schedule.breadcrumbs.settings',
                  requiresAuth: true,
                  requiredPerm: 'class_schedules.update',
                },
                props: true
              }
            ]
          }
        ]
      },
      {
        path: ':id/subjects',
        name: 'class-subjects',
        component: ClassSubjects,
        meta: { 
          title: 'subjects.breadcrumbs.classSubjects',
          requiresAuth: true,
          requiredPerm: 'subjects.display',
        }
      },
      {
        path: ':id/subjects/add',
        name: 'add-class-subject',
        component: AddSubjectToClass,
        meta: { 
          title: 'subjects.breadcrumbs.addSubject',
          requiresAuth: true,
          requiredPerm: 'subjects.create',
        }
      },
      {
        path: ':classId/subjects/:subjectId/edit',
        name: 'edit-class-subject',
        component: EditSubjectToClass,
        props: true,
        meta: { 
          title: 'subjects.breadcrumbs.editSubject',
          requiresAuth: true,
          requiredPerm: 'subjects.update',
        }
      }
    ]
  },
  {
    path: '/exams-schedule',
    name: 'exams.management',
    component: ExamScheduleIndex,
    meta: { 
      requiresAuth: true,
      title: 'exams.breadcrumbs.management',
      requiredPerm: 'exam_gate_schedules.display',
    },
    children: [
      {
        path: ':classId/exam-schedule',
        name: 'exams.schedule',
        component: ExamScheduleView,
        meta: { 
          requiresAuth: true,
          title: 'exams.breadcrumbs.schedule',
          requiredPerm: 'exam_schedules.display',
        },
        props: true
      },
      {
        path: ':classId/schedule/settings',
        name: 'exams.schedule.settings',
        component: ExamScheduleSettings,
        meta: { 
          requiresAuth: true,
          title: 'exams.breadcrumbs.settings',
          requiredPerm: 'exam_schedules.update',
        },
        props: true
      }
    ]
  }
];